module.exports = __webpack_public_path__ + "img/viet.bb9468ee.png";